import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { OidcProvider } from "./Utils/Oidc/oidcRedux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import App from "./components/App";
import userManager from "./Utils/Oidc/userManager";
import { setupAxiosInterceptors } from "./Utils/apis/interceptors";
import "./Assets/css/main.scss";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

setupAxiosInterceptors();

createRoot(document.getElementById("app")).render(
  <BrowserRouter>
    <Provider store={store}>
      <OidcProvider userManager={userManager}>
        <I18nextProvider i18n={i18n} useSuspense={false}>
          <App />
        </I18nextProvider>
      </OidcProvider>
    </Provider>
  </BrowserRouter>
);
